import styled from "styled-components";

const MapWrapper = styled.div`
  height: 450px;
  width: 100%;
`;

export default MapWrapper;
